import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { Dialog, DialogContent, DialogContentText, DialogTitle, Box, Link } from '@mui/material';

export const useStyles = makeStyles({
  icon: {
    fontSize: 60,
  },
});

const Props = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default function SubscriptionProcessingModal({ open, onClose }) {
  const classes = useStyles();

  return (
    <Dialog maxWidth="xs" open={open} onClose={onClose}>
      <Box p={3} textAlign="center">
        <AccessTimeIcon className={classes.icon} />

        <DialogTitle>
          {true ? <b>Subscription failed</b> : <b>Processing payment...</b>}
        </DialogTitle>

        <DialogContent>
          {true ? (
            <DialogContentText>
              Looks like your subscrption failed. Don't worry you can try again.
            </DialogContentText>
          ) : (
            <DialogContentText>
              SEPA Direct Debit is a reusable and delayed notification payment method. Which means
              it takes an average of 5 working days for your payment to be confirmed and your
              subscription to be activated (the deadline for this confirmation is 14 working days).
            </DialogContentText>
          )}
        </DialogContent>

        <Box mt={3}>
          <Link onClick={onClose} underline="hover">
            {true ? 'Retry' : 'Close'}
          </Link>
        </Box>
      </Box>
    </Dialog>
  );
}

SubscriptionProcessingModal.propTypes = Props;
